module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/EH-178b741d62d080baf481c6a606a9e488.png";